import * as React from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import useGlobalState, { DocumentData, SMSStatus, UserData } from '../global_state'
import { DataFetcher } from '../services/fetch_data'
import { Chip, Container, Divider, LinearProgress, Stack, TableFooter, TablePagination, TextField, useTheme } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import MobileNumberTextField from './mobile_number_text_field'
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined'
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined'
import UserService from '../services/user_service'
import { useSnackbar } from 'notistack'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import { SearchType, filterData } from 'filter-data'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2'
import DatePickerField from './date_picker_field'
import { useAuth } from '../providers/auth_provider'
import axios, { AxiosError } from 'axios'

export const readableDate = (timestamp: number) => dayjs(new Date(timestamp)).format("DD.MM.YYYY")

export const roundDate = (date: number): number => {
    let startDateUnformated = new Date(date)
    startDateUnformated.setHours(0)
    startDateUnformated.setMinutes(0)
    startDateUnformated.setSeconds(0)
    startDateUnformated.setMilliseconds(0)

    return startDateUnformated.getTime()
}

export const getMonday = (): number => {
    const date = dayjs(new Date())
    const startOfWeek = date.startOf("week")

    return startOfWeek.unix() * 1000
}

export const getFriday = (): number => {
    const date = dayjs(new Date())
    const startOfWeek = date.endOf("week")

    return startOfWeek.unix() * 1000
}

const Row = (document: DocumentData, startDate: number, endDate: number) => {
    const { token, logout } = useAuth()
    const userService = new UserService(token)
    const [open, setOpen] = React.useState(false)
    const [mobileNumber, setMobileNumber] = React.useState("")
    const [error, setError] = React.useState(false)
    const [user, setUser] = React.useState<UserData | null>(null)
    const [update, setUpdate] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [_, setDocuments] = useGlobalState("documentsData")
    const { enqueueSnackbar } = useSnackbar()

    React.useEffect(() => {
        setUser(document.user)
    }, [document])

    React.useEffect(() => {
        if (user != null) {
            setMobileNumber(user?.phoneNumber.replace("+359", ""))
        }
    }, [user])

    const enableUpdate = () => {
        setUpdate(true)
    }

    const updateMobileNumber = (value: string) => {
        setMobileNumber(value)
        setError(false)
    }

    const sendMobileNumber = async () => {
        const mobileNumberTrim = mobileNumber.trim().split(" ").join("")
        console.log(mobileNumberTrim)

        if (mobileNumberTrim.length != 9 || user == null) {
            setError(true)
        } else {
            setLoading(true)

            try {
                await userService.updateMobileNumber(user.id, `+359${mobileNumberTrim}`)
                const [documents] = await DataFetcher.fetchUsers(token, startDate, endDate)

                setDocuments(documents)
                enqueueSnackbar('Записано', { variant: "success" })
            } catch (e) {
                if (axios.isAxiosError(e) && (e as AxiosError).status == 401) {
                    enqueueSnackbar('Влез отново', { variant: "error" })
                    logout()
                }
            }

            setLoading(false)
            setUpdate(false)
        }
    }

    return (
        <React.Fragment>
            <TableRow>
                <TableCell>
                    <IconButton
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
                    </IconButton>
                </TableCell>
                <TableCell>{document.id.replaceAll("/", "-")}</TableCell>
                <TableCell>{document.type}</TableCell>
                <TableCell align='right'>{readableDate(document.fromDate)}</TableCell>
                <TableCell align='right'>{readableDate(document.dueDate)}</TableCell>
                <TableCell>{user?.name}</TableCell>
                <TableCell>
                    {loading ?
                        <LinearProgress /> :
                        <Stack
                            direction="row"
                            // divider={<Divider orientation="vertical" flexItem />}
                            spacing={1}
                        >
                            <MobileNumberTextField
                                hasTitle={false}
                                value={mobileNumber}
                                setValue={updateMobileNumber}
                                hasError={error}
                                disabled={!update} />
                            {update ?
                                <IconButton
                                    size='small'
                                    disabled={mobileNumber == "" || error}
                                    onClick={sendMobileNumber}>
                                    <DoneOutlinedIcon fontSize='small' />
                                </IconButton> :
                                <IconButton size='small' onClick={enableUpdate}>
                                    <ModeEditOutlinedIcon fontSize='small' />
                                </IconButton>}
                        </Stack>}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={4} />
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3} >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <div style={{ fontWeight: "bold" }}>
                                SMS-и за изпращане
                            </div>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Изпращане до</TableCell>
                                        <TableCell align='center'>Статус</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {document.schedueldSMS.map((smsData, i) => (
                                        <TableRow key={`SMS-${document.id}-${i}`}>
                                            <TableCell component="th" scope="row">
                                                {readableDate(smsData.dueDate)}
                                            </TableCell>
                                            <TableCell align='center'>{smsData.status == SMSStatus.sent ? <Chip label="Изпратен" color="success" size="small" variant="outlined" /> :
                                                smsData.status == SMSStatus.error ?
                                                    <Chip label="Неизпратен" color="error" size="small" variant="outlined" /> :
                                                    <Chip label="Неизпратен" color="info" size="small" variant="outlined" />
                                            }</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

interface TablePaginationActionsProps {
    count: number
    page: number
    rowsPerPage: number
    onPageChange: (
        event: React.MouseEvent<HTMLButtonElement>,
        newPage: number,
    ) => void
}

function TablePaginationActions(props: TablePaginationActionsProps) {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props

    const handleFirstPageButtonClick = (
        event: React.MouseEvent<HTMLButtonElement>,
    ) => {
        onPageChange(event, 0)
    }

    const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page - 1)
    }

    const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page + 1)
    }

    const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page">
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    )
}


export const SheduledSMSTable = () => {
    const { token, logout } = useAuth()
    const [documents, setDocuments] = useGlobalState("documentsData")
    const [page, setPage] = React.useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [searchString, setSearchString] = React.useState("")
    const [filteredDocuments, setFiltredDocuments] = React.useState<DocumentData[]>(Object.values(documents ?? {}))
    const [startDate, setStartDate] = React.useState<Dayjs | null>(dayjs(new Date(getMonday())))
    const [endDate, setEndDate] = React.useState<Dayjs | null>(dayjs(new Date(getFriday())))

    const updateStartDate = (value: Dayjs | null) => {
        setStartDate(value)
    }
    const updateEndDate = (value: Dayjs | null) => {
        setEndDate(value)
    }

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredDocuments.length) : 0

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const handleSearchStringChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchString(e.target.value)
    }

    const fetchData = async () => {
        try {
            const [documents] = await DataFetcher.fetchUsers(token, (startDate?.unix() ?? 0) * 1000, (endDate?.unix() ?? 0) * 1000)
            setDocuments(documents)
        } catch (e) {
            if (axios.isAxiosError(e) && (e as AxiosError).status == 401) {
                logout()
            }
        }
    }

    React.useEffect(() => {
        fetchData()
    }, [startDate, endDate])

    React.useEffect(() => {
        console.log(documents)
        console.log(getMonday())
        const stDate = (startDate?.unix() ?? 0) * 1000
        const enDate = (endDate?.unix() ?? 0) * 1000

        let filterByDate
        if (searchString.trim() != "") {
            filterByDate = Object.values(documents ?? {})
        } else {
            filterByDate = Object.values(documents ?? {}).filter(document => {
                let shouldBeIncluded = false
                document.schedueldSMS.forEach(smsData => {
                    if (smsData.dueDate <= enDate && smsData.dueDate >= stDate) {
                        shouldBeIncluded = true
                    }
                })

                return shouldBeIncluded
            })
        }

        const searchConditions = [
            {
                key: ['id', 'type', "user.name", "user.phoneNumber"],
                value: searchString,
                type: SearchType.LK,
            }
        ]

        const result = filterData(filterByDate, searchConditions)

        setFiltredDocuments(result)

    }, [searchString, documents, startDate, endDate])

    return (
        <Container maxWidth={false} component={Paper}  >
            <Grid2 container>
                <Grid2 lg={2} padding={4} spacing={1}>
                    <TextField size="small" value={searchString} onChange={handleSearchStringChange} label='Търси' />
                </Grid2>
                <Grid2 lg={2} padding={4} spacing={1}>
                    <DatePickerField value={startDate} setValue={updateStartDate} label={'Начало на период'} disabled={false} />
                </Grid2>
                <Grid2 lg={2} padding={4} spacing={1}>
                    <DatePickerField value={endDate} setValue={updateEndDate} label={'Край на период'} disabled={false} />
                </Grid2>
            </Grid2>
            <TableContainer >
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell width="1%" />
                            <TableCell width="10%">Полица №</TableCell>
                            <TableCell width="20%">Услуга</TableCell>
                            <TableCell width="5%">Изготвена на</TableCell>
                            <TableCell width="5%">Изтича на</TableCell>
                            <TableCell width="10%">Клиент</TableCell>
                            <TableCell width="10%">Телефонен номер</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            filteredDocuments
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((document: DocumentData) => (
                                    <Row key={document.id} {...document} />
                                ))
                        }
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                            </TableRow>
                        )}

                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50, { label: 'All', value: -1 }]}
                                colSpan={7}
                                count={filteredDocuments.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: {
                                        'aria-label': 'rows per page',
                                    },
                                    native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </Container>
    )
}
